var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"energy"},[_c('titlePage',{attrs:{"item":_vm.title}}),_c('div',{staticClass:"energy-box"},[_c('chartsBar',{attrs:{"option":_vm.barData,"id":"energyBox"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }